import { render, staticRenderFns } from "./Mappa.vue?vue&type=template&id=104d6b31&scoped=true&"
import script from "./Mappa.vue?vue&type=script&lang=js&"
export * from "./Mappa.vue?vue&type=script&lang=js&"
import style0 from "./Mappa.vue?vue&type=style&index=0&id=104d6b31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d6b31",
  null
  
)

export default component.exports